import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OnSiteMovementEditPage } from './on-site-movement-edit';
import { PipesModule } from '../../../pipes/pipes.module';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OnSiteMovementEditPage,
  ],
  imports: [
    IonicPageModule.forChild(OnSiteMovementEditPage),
    PipesModule,
    TextMaskModule,
    SharedModule,
    FoundationModule,
    DirectivesModule,
  ],
  exports: [
    OnSiteMovementEditPage
  ]
})
export class OnSiteMovementEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/on-site-movement/on-site-movement-edit/on-site-movement-edit.module.ts